import { EUserRole } from '@/models/dtos/enums/eUerRole'
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import { AuthService as _authService } from '@/services/auth.service'
import Home from '@/views/Home.vue'
import { component } from 'vue/types/umd'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  // Unauthorized routes
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { unauthorize: true }
  },

  // Authorized routes
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { authorize: [] }
  },
  {
    path: '/profil',
    name: 'Profil',
    component: () => import('@/views/Profil.vue'),
    meta: { authorize: [] }
  },
  {
    path: '/workbook',
    name: 'Workbook',
    component: () => import('@/views/Workbook.vue'),
    meta: { authorize: [] }
  },
  {
    path: '/announcements',
    name: 'Announcements',
    component: () => import('@/views/Announcement.vue'),
    meta: { authorize: [] }
  },
  {
    // Project routes
    path: '/project',
    name: 'Project',
    component: () => import('@/views/Project/Main.vue'),
    children: [
      {
        path: 'details/:id',
        name: 'ProjectDetails',
        component: () => import('@/views/Project/Details.vue')
      },
      {
        path: 'create',
        name: 'ProjectCreate',
        component: () => import('@/views/Project/CreateOrUpdate.vue')
      },
      {
        path: 'edit/:id',
        name: 'ProjectEdit',
        component: () => import('@/views/Project/CreateOrUpdate.vue')
      }
    ]
  },

  // Admin routes
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('@/admin/views/Main.vue'),
    meta: { authorize: [EUserRole.Admin] },
    children: [
      // Account
      {
        path: 'account',
        name: 'AdminAccount',
        component: () => import('@/admin/views/account/Main.vue'),
        children: [
          {
            path: 'list',
            name: 'AdminAccountList',
            component: () => import('@/admin/views/account/List.vue')
          },
          {
            path: 'add',
            name: 'AdminAccountAdd',
            component: () => import('@/admin/views/account/CreateOrUpdate.vue')
          },
          {
            path: 'edit/:id',
            name: 'AdminAccountEdit',
            component: () => import('@/admin/views/account/CreateOrUpdate.vue')
          }
        ]
      },
      // Template
      {
        path: 'template',
        name: 'AdminTemplate',
        component: () => import('@/admin/views/template/Main.vue'),
        children: [
          {
            path: 'list',
            name: 'AdminTemplateList',
            component: () => import('@/admin/views/template/List.vue')
          },
          {
            path: 'add',
            name: 'AdminTemplateAdd',
            component: () => import('@/admin/views/template/CreateOrUpdate.vue')
          },
          {
            path: 'edit/:id',
            name: 'AdminTemplateEdit',
            component: () => import('@/admin/views/template/CreateOrUpdate.vue')
          }
        ]
      },
      // EmployeeType
      {
        path: 'employeeType',
        name: 'AdminEmployeeType',
        component: () => import('@/admin/views/employeeType/Main.vue'),
        children: [
          {
            path: 'list',
            name: 'AdminEmployeeTypeList',
            component: () => import('@/admin/views/employeeType/List.vue')
          },
          {
            path: 'add',
            name: 'AdminEmployeeTypeAdd',
            component: () => import('@/admin/views/employeeType/CreateOrUpdate.vue')
          },
          {
            path: 'edit/:id',
            name: 'AdminEmployeeTypeEdit',
            component: () => import('@/admin/views/employeeType/CreateOrUpdate.vue')
          }
        ]
      },
      // Announcements
      {
        path: 'announcements',
        name: 'AdminAnnouncements',
        component: () => import('@/admin/views/announcements/Main.vue'),
        children: [
          {
            path: 'list',
            name: 'AdminAnnouncementList',
            component: () => import('@/admin/views/announcements/List.vue')
          },
          {
            path: 'add',
            name: 'AdminAnnouncementAdd',
            component: () => import('@/admin/views/announcements/CreateOrUpdate.vue')
          },
          {
            path: 'edit/:id',
            name: 'AdminAnnouncementEdit',
            component: () => import('@/admin/views/announcements/CreateOrUpdate.vue')
          }
        ]
      },
      // Projects
      {
        path: 'projects',
        name: 'AdminProjects',
        component: () => import('@/admin/views/project/Main.vue'),
        children: [
          {
            path: 'list',
            name: 'AdminProjectList',
            component: () => import('@/admin/views/project/List.vue')
          }
        ]
      }
    ]
  },

  // Not existing routs
  {
    path: '*',
    redirect: {
      name: 'Home'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Auth
router.beforeEach((to: any, from: any, next: any) => {
  const { authorize, unauthorize } = to.meta
  const currentUser = _authService.currentUserValue

  if (to.name) {
    (window as any).NProgress.start()
  }

  // Do not allow logged user to view for unauthorize
  if (unauthorize && currentUser) {
    return next({ path: '/' })
  }

  if (authorize) {
    if (!currentUser) {
      return next({ path: '/login', query: { returnUrl: to.path } })
    }

    if (authorize.length && !authorize.some((authRole: string) => currentUser.roles.includes(authRole))) {
      return next({ path: '/' })
    }
  }

  next()
})

router.afterEach((to: any, from: any) => {
  (window as any).NProgress.done()
})

export default router
